import useCookies from '../../config/hooks/useCookies'

import { Banner, Btn } from './styles'

const CookieBanner = () => {
  const { show, action } = useCookies()

  return (
    <Banner {...{ show }}>
      <h1 className="title">ABOUT COOKIES ON THE WEBSITE</h1>

      <p className="content">
        By clicking on the “Accept” button you consent to the usage of 1st and
        3rd party cookies (or similar) in order to enhance your overall web
        browsing experience, measure our audience, and collect useful
        information.
      </p>

      <p className="learn-more">
        Learn more about our Cookies policy{' '}
        <a
          className="link"
          href="https://www.nestle-cereals.com/webar-cookies-notice"
          target="_blank"
          rel="noreferrer"
        >
          here
        </a>
        .
      </p>

      <div className="banner-buttons">
        <Btn onClick={() => action('accept')} userAction="accept">
          Accept analytics cookies
        </Btn>

        <Btn onClick={() => action('decline')}>Decline</Btn>
      </div>
    </Banner>
  )
}

export default CookieBanner
